import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Marcus T.",
    role: "Day Trader, 3 years",
    quote:
      "Caught BITX at $38.50 before the 40% run. The SMS hit my phone 6 minutes before Twitter started buzzing.",
    rating: 5,
  },
  {
    name: "Sarah K.",
    role: "Swing Trader",
    quote:
      "I was spending 3 hours a day scanning charts. Now I set my thresholds and RadarTicker does the heavy lifting.",
    rating: 5,
  },
  {
    name: "James R.",
    role: "Part-time Trader",
    quote:
      "The pre-market alerts alone paid for my Pro subscription in the first week. Game changer for people with day jobs.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 px-6 bg-muted/40">
      <div className="container mx-auto">
        <div className="max-w-2xl mx-auto text-center mb-14">
          <p className="text-sm font-semibold text-accent uppercase tracking-wide mb-3">
            Trusted by traders
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-balance">
            Don't take our word for it
          </h2>
          <p className="text-lg text-muted-foreground">
            Hear from traders who stopped missing moves.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-card border border-border rounded-xl p-6 flex flex-col"
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="h-4 w-4 text-cta fill-cta" />
                ))}
              </div>
              <blockquote className="text-[15px] leading-relaxed text-foreground mb-6 flex-1">
                "{t.quote}"
              </blockquote>
              <div>
                <p className="font-semibold text-sm">{t.name}</p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
